import { Component, OnInit } from '@angular/core'
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MatDialog } from '@angular/material/dialog'
import { CodigoUnidadeSigad } from 'src/app/models/codigo-unidade-sigad.model'
import { SigadDadosBasicos, SigadEnvioStatus, SigadProtocolo } from 'src/app/models/sigad-protocolo'
import { LocalStorageService } from 'src/app/services/local-storage.service'
import { SigadService } from 'src/app/services/sigad.service'
import { ConcursoService } from 'src/app/services/concurso.service'
import { UnespCoreMessageService } from 'src/libs/unesp-core'
import { SigadPreviewDialogComponent } from '../../sigad-preview-dialog/sigad-preview-dialog.component'

@Component({
  selector: 'app-processo-digital',
  templateUrl: './processo-digital.component.html',
  styleUrls: ['./processo-digital.component.css'],
})
export class ProcessoDigitalComponent implements OnInit {
  public idConcurso?: number
  public titulo?: string
  get tituloPage(): string {
    if (this.idConcurso) {
      const tituloValue = this.titulo?.trim();
      return tituloValue ? `Concurso #${this.idConcurso}: ${tituloValue}` : `Concurso #${this.idConcurso}`;
    }
    return 'Concurso';
  }
  public progressBarValue = 0
  public progressBarShow = false

  public codigoUnidadeUsuario = new CodigoUnidadeSigad('0')
  public codigoUnidadeLocalizacao = new CodigoUnidadeSigad('0')

  public statusInscricoes: SigadEnvioStatus = { permitido: false, totalCompleto: 0, total: 0 }
  public statusDeclaracoes: SigadEnvioStatus = { permitido: false, totalCompleto: 0, total: 0 }
  public statusResultadoFase1: SigadEnvioStatus = { permitido: false, totalCompleto: 0, total: 0 }
  public statusResultadoFase2: SigadEnvioStatus = { permitido: false, totalCompleto: 0, total: 0 }



  public prazoInscricaoEncerrado = false
  public temInscricoesAguardandoAnalise = false

  public protocoloForm = new FormGroup({
    numero: new FormControl('', [Validators.required]),
    unidadeProtocolo: new FormControl(''),
    categoria: new FormControl(''),
    tipoMeio: new FormControl(''),
    dataCadastro: new FormControl(''),
    usuarioCadastro: new FormControl(''),
    situacao: new FormControl(''),
    tipoDocumental: new FormControl(''),
    classificacao: new FormControl(''),
    assunto: new FormControl(''),
    acesso: new FormControl(''),
    localizacao: new FormControl('', [
      this.validarLocalizacaoComUsuarioLogado(this.getCodigoLocalizacaoUsuarioLogado()),
    ]),
    procedencia: new FormControl(''),
  })

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private sigadService: SigadService,
    private concursoService: ConcursoService,
    private localstorage: LocalStorageService,
    private readonly unespCoreMessageService: UnespCoreMessageService
  ) {}

  ngOnInit(): void {
    ;(this.route.parent?.params || this.route.params).subscribe(params => {
      const idConcurso = params['id'] || params['idConcurso']
      this.idConcurso = idConcurso
      this.loadProtocoloData(idConcurso)
      this.loadConcursoTitulo(idConcurso)
    })
  }
  private loadConcursoTitulo(idConcurso: number): void {
    this.concursoService.get(idConcurso).subscribe(concurso => {
      this.titulo = concurso.titulo;
      this.prazoInscricaoEncerrado = new Date() > new Date(concurso.fim + 'T' + concurso.horaFim);
    });
  }
  private loadProtocoloData(idConcurso: number): void {
    this.sigadService.getProtocolo(idConcurso).subscribe(({ content: data, meta }: SigadDadosBasicos) => {
      this.codigoUnidadeLocalizacao = new CodigoUnidadeSigad(data.procedencia.codigo)
      this.populateForm(data)
      this.protocoloForm.markAllAsTouched()

      this.statusInscricoes = meta.statusInscricoes
      this.statusDeclaracoes = meta.statusDeclaracoes
      this.statusResultadoFase1 = meta.statusResultadoFase1
      this.statusResultadoFase2 = meta.statusResultadoFase2

      this.temInscricoesAguardandoAnalise = !meta.statusInscricoes.permitido && this.prazoInscricaoEncerrado

    })
  }

  private populateForm(data: SigadProtocolo): void {
    this.protocoloForm.patchValue({
      numero: data.numero,
      unidadeProtocolo: `${data.unidadeProtocolo.codigo} - ${data.unidadeProtocolo.nome}`,
      categoria: data.categoria,
      tipoMeio: data.tipoMeio,
      dataCadastro: data.dataCadastro,
      usuarioCadastro: data.usuarioCadastro,
      situacao: data.situacao,
      tipoDocumental: `${data.classificacaoAssunto.codigoTipoDocumental} - ${data.classificacaoAssunto.nomeTipoDocumental}`,
      classificacao: `${data.classificacaoAssunto.codigoClassificacao} - ${data.classificacaoAssunto.nomeClassificacao}`,
      assunto: data.classificacaoAssunto.assunto,
      acesso: data.classificacaoAssunto.acesso,
      localizacao: `${data.localizacao.codigo} - ${data.localizacao.nome}`,
      procedencia: `${data.procedencia.codigo} - ${data.procedencia.nome}`,
    })
  }

  voltar() {
    this.router.navigate(['/concurso'])
  }

  validarLocalizacaoComUsuarioLogado(codigoUnidadeUsuarioLogado: CodigoUnidadeSigad | null) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!codigoUnidadeUsuarioLogado) return null

      if (!control.value) return null

      const codigo = control.value.split(' - ')[0]
      console.log({ codigo })

      if (!codigo) return { invalidCodigoPrefix: true }

      console.log({ codigo })

      const isValid = codigoUnidadeUsuarioLogado.comparar(new CodigoUnidadeSigad(codigo), 1)

      return isValid ? null : { invalidCodigoPrefix: true }
    }
  }

  getCodigoLocalizacaoUsuarioLogado() {
    const user = this.localstorage.get('_user')

    if (!user?.clientDetails?.unidade) return null

    return new CodigoUnidadeSigad(user.clientDetails.unidade)
  }

  enviarDocs() {
    this.progressBarShow = true
    this.sigadService.enviarDocumentos(this.idConcurso!).subscribe({
      next: progress => {
        this.progressBarValue = (progress.current / progress.total) * 100
      },
      error: () => {
        this.progressBarValue = 0
      },
      complete: () => {
        this.progressBarShow = false
        this.unespCoreMessageService.showMessageSuccess('Inscrições enviadas com sucesso')

        if (this.idConcurso) {
          this.loadProtocoloData(this.idConcurso)
          this.loadConcursoTitulo(this.idConcurso)
        }
      },
    })
  }

  enviarDeclaracoes() {
    this.sigadService.enviarDeclaracoes(this.idConcurso!).subscribe(res => {
      if (res?.length === 0) {
        return this.unespCoreMessageService.showMessageWarning('Não há declarações para atualizar!')
      }

      if (res?.length > 0) {
        this.unespCoreMessageService.showMessageSuccess('Declarações atualizadas com sucesso!')
        this.loadProtocoloData(this.idConcurso!)
      }
    })
  }

  enviarClassificacaoFase1() {
    const dialogRef = this.dialog.open(SigadPreviewDialogComponent, {
      width: '90vw',
      height: '90vh',
      panelClass: 'fullheight-dialog',
      data: {
        titulo: 'Pré-visualização - Resultado da Fase 1',
        urlPdf: this.sigadService.getClassificacaoFase1PdfUrl(this.idConcurso!),
      },
    })

    dialogRef.afterClosed().subscribe(confirmado => {
      if (confirmado) {
        this.sigadService.enviarClassificacaoFase1(this.idConcurso!).subscribe(res => {
          if (res?.length > 0) {
            this.unespCoreMessageService.showMessageSuccess('Classificação Fase 1 enviada ao SIGAD com sucesso!')
            this.loadProtocoloData(this.idConcurso!)
          }
        })
      }
    })
  }

  enviarClassificacaoFase2() {
    const dialogRef = this.dialog.open(SigadPreviewDialogComponent, {
      width: '90vw',
      height: '90vh',
      panelClass: 'fullheight-dialog',
      data: {
        titulo: 'Pré-visualização - Resultado da Fase 2',
        urlPdf: this.sigadService.getClassificacaoFase2PdfUrl(this.idConcurso!),
      },
    })

    dialogRef.afterClosed().subscribe(confirmado => {
      if (confirmado) {
        this.sigadService.enviarClassificacaoFase2(this.idConcurso!).subscribe(res => {
          if (res?.length === 0) {
            return this.unespCoreMessageService.showMessageWarning('Não há classificações para atualizar!')
          }

          if (res?.length > 0) {
            this.unespCoreMessageService.showMessageSuccess('Classificações atualizadas com sucesso!')
            this.loadProtocoloData(this.idConcurso!)
          }
        })
      }
    })
  }

  get formErrors(): string[] {
    const errors: string[] = []

    if (this.protocoloForm.get('localizacao')?.hasError('invalidCodigoPrefix')) {
      errors.push(
        'A localização do documento (processo no SIGAD) precisa estar na unidade responsável pelo concurso para a funcionalidade Atualizar processo digital ser habilitada para uso.'
      )
    }

    return errors
  }
}
